// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"styles_cardsContainer__qGqfl","card":"styles_card__OOfIx","badge":"styles_badge__3ukm2"};